import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import template from '@bingads-webui-campaign-legacy/campaign-bulk-edit/template/bulkEditAdScheduleTimeZone.pug';
import ViewModel from '@bingads-webui-campaign-legacy/campaign-bulk-edit/viewmodel/bulkEditAdScheduleTimeZone';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

export default class View extends BaseView {
  initialize(options) {
    super.initialize(options);
    this.template = template;
    this.options = options;
    this.onOperationSuccess = options.onOperationSuccess;
    // eslint-disable-next-line camelcase
    this.ko_model = new ViewModel(this.model);
  }

  attributes() {
    return {
      'class': 'schedule-timezone-setting',
    };
  }

  render() {
    super.render();

    return this;
  }

  setAction() {
    const action = {
      Actions: [{
        '@odata.type': '#Model.TextAction',
        Property: 'AdScheduleUseSearcherTimeZone',
        ActionType: 'Set',
        Value: this.ko_model.adScheduleUseSearcherTimeZone().toString(),
        SearchString: '',
        Options: 'None',
      }],
    };

    this.model.set('BatchAction', action);
    this.model.set('Entity', this.model.attributes.entity);
  }

  getIdFilter() {
    return filterHelper.getIdFilter(this.grid, this.model.attributes.entity);
  }

  getProgressText() {
    return i18n.getString('BulkEdit_Campaigns_ProgressText');
  }
}
